import { Component, OnInit } from '@angular/core';
import { ProjectInfoService } from '../project-info.service';
import { IndexView } from '../project-info.interface';

/**
 * Editor toolbar.
 */
@Component({
  selector: 'sg2-project-info-toolbar',
  templateUrl: './project-info-toolbar.component.html',
  styleUrls: ['./project-info-toolbar.component.less']
})
export class ProjectInfoToolbarComponent implements OnInit {

  /**
   * TinyMCE config.
   *
   * Used for preloading TinyMCE to make sure it's always ready on click in document view.
   */
  public readonly config = {
    menubar: false,
    fixed_toolbar_container: '#toolbar-container-tinymce'
  };

  /** Whether inline edit mode is active. */
  public currentEditInline = true;

  /** Current active view. */
  public currentView: IndexView;

  /** Current active view. @deprecated */
  public editMode: IndexView;

  /** List of index views. */
  public views: IndexView[];

  constructor(
    private projectInfoService: ProjectInfoService
  ) { }

  ngOnInit() {
    this.currentView = this.projectInfoService.getIndexViewDefault();
    this.views = this.projectInfoService.getIndexViews();
  }

  /**
   * Set edit mode.
   *
   * @deprecated
   *
   * @param active Whether to enable or disable inline edit.
   */
  public setEditMode(active: boolean): void {
    this.projectInfoService.setInlineEdit(active);
  }

  /**
   * Set the current active index view.
   *
   * @param view Selected view.
   */
  public setView(view: IndexView): void {
    this.projectInfoService.setIndexView(view._id);
  }
}
